import { IConfigOtp, IOtpPortabilityMobile, IPersonalInfo } from '@vfit/consumer/data-access';
import { fonts, pxToLineHeight } from '@vfit/shared/themes';
import { RegisterOptions } from 'react-hook-form';

export const organizeOtp = (
  personalInfo: IPersonalInfo,
  msisdnOrEmail: any,
  contactMedium: any
): IConfigOtp => ({
  title: personalInfo?.clientRecognition?.title || '',
  description: personalInfo?.clientRecognition?.description || '',
  codeResponseDescription: personalInfo?.clientRecognition?.codeResponse?.description || '',
  instructionText: {
    text: msisdnOrEmail
      ? `${personalInfo?.clientRecognition?.telephoneVerify?.replace(
          '$number',
          `<b style="color:red">${contactMedium.field}</b>`
        )}`
      : `${personalInfo?.clientRecognition?.emailVerify?.replace(
          '$email',
          `
<div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
    <b style="color:red">${contactMedium?.field || ''}</b>
</div>
`
        )}`,
    fontFamily: fonts.exbold,
    size: 20,
    lineHeight: pxToLineHeight(20, 26),
  },
  alerts: {
    error: personalInfo?.clientRecognition?.codeResponse?.alertWarn || '',
    sentNew: personalInfo?.clientRecognition?.codeResponse?.alertSuccess || '',
  },
  otpError: personalInfo?.clientRecognition?.codeResponse?.otpError || '',
  detail: personalInfo?.clientRecognition?.codeMissingLabel || '',
  links: {
    sendNew: personalInfo?.clientRecognition?.codeNewLabel || '',
    noAccess: personalInfo?.clientRecognition?.codeNotAccessLabel || '',
    urlNoAccess: personalInfo?.clientRecognition?.contactNotAccessUrl || '',
  },
  timer: {
    timerLabel: personalInfo?.clientRecognition?.timer?.label?.replace(
      '$TIME',
      `<b id="timerAmount">${personalInfo?.clientRecognition?.timer?.amount}</b>`
    ),
  },
});

export const organizeOtpPortability = (
  dataFromCms: IOtpPortabilityMobile,
  msisdnOrEmail: any,
  contactMedium: any
): IConfigOtp => ({
  title: dataFromCms?.title || '',
  description: dataFromCms?.description || '',
  codeResponseDescription: dataFromCms?.codeResponse?.description || '',
  instructionText: {
    text: msisdnOrEmail
      ? `${dataFromCms?.telephoneVerify?.replace(
          '$number',
          `<b style="color:red">${contactMedium.field}</b>`
        )}`
      : `${dataFromCms?.emailVerify?.replace(
          '$email',
          `
<div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
    <b style="color:red">${contactMedium?.field || ''}</b>
</div>
`
        )}`,
    fontFamily: fonts.exbold,
    size: 20,
    lineHeight: pxToLineHeight(20, 26),
  },
  alerts: {
    error: dataFromCms?.codeResponse?.alertWarn || '',
    sentNew: dataFromCms?.codeResponse?.alertSuccess || '',
  },
  otpError: dataFromCms?.codeResponse?.otpError || '',
  detail: dataFromCms?.codeMissingLabel || '',
  links: {
    sendNew: dataFromCms?.codeNewLabel || '',
    noAccess: dataFromCms?.codeNotAccessLabel || '',
    urlNoAccess: dataFromCms?.contactNotAccessUrl || '',
  },
  timer: {
    timerLabel: dataFromCms?.timer?.label?.replace(
      '$TIME',
      `<b id="timerAmount">${dataFromCms?.timer?.amount}</b>`
    ),
  },
});

export const otpFormSchema: Record<'otp', RegisterOptions> = {
  otp: {
    required: {
      value: true,
      message: 'Campo obbligatorio',
    },
    pattern: {
      value: /^[0-9]{6}$/,
      message: 'Codice errato, riprova',
    },
  },
};

